import { useMemo } from 'react';
import { useProfileV2 } from '../Profile';
import { type SupportedCountries } from './useCountries';

type SupportedCompany = {
  hasAccess: boolean;
  countries: SupportedCountries;
};

export type SupportedCompanies = {
  recycling: SupportedCompany;
  confidential: SupportedCompany;
};

const getAllCompanies = () => {
  return {
    recycling: {
      hasAccess: true,
      countries: {
        sweden: true,
        denmark: true,
        norway: true,
        finland: true,
        poland: true,
      },
    },
    confidential: {
      hasAccess: true,
      countries: {
        sweden: true,
        denmark: true,
        norway: true,
        finland: true,
        poland: true,
      },
    },
  } as SupportedCompanies;
};

export const useCompanies = () => {
  const { profile } = useProfileV2();

  const supportedCompanies: SupportedCompanies = useMemo(() => {
    if (!profile?.aggregatedPermissions) {
      return getAllCompanies();
    }

    const companies = profile.aggregatedPermissions.companies;

    const retval = {
      recycling: {
        hasAccess: companies.stenaRecycling.hasAccess,
        countries: companies.stenaRecycling.markets,
      },
      confidential: {
        hasAccess: companies.stenaConfidential.hasAccess,
        countries: companies.stenaConfidential.markets,
      },
    };

    return retval;
  }, [profile]);

  return { supportedCompanies };
};
